import type { RouteMeta } from 'vue-router'

import type { SoftwareCode } from '../stores/session'

import type { SharedViewMeta } from './meta'

/**
 * The breadcrumb and the highlighted nav entry of a route for the software the screen works in (`useCurrentSoftware()`):
 * the route's own, or — for a user who opened it through `meta.sharedWith` — its `meta.sharedView` for that software
 * (an employee on `/en/surveys/:id` gets the `/em/surveys` crumbs and nav entry, SHARED_CHANGES_QUEUE #28).
 */
export function sharedViewMeta(meta: RouteMeta, software: SoftwareCode | null | undefined): SharedViewMeta {
  const shared = software && software !== meta.software ? meta.sharedView?.[software] : undefined
  return {
    breadcrumb: shared?.breadcrumb ?? meta.breadcrumb,
    navActiveLink: shared?.navActiveLink ?? meta.navActiveLink,
  }
}
